import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";

// Pages
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import QuotePage from "@/pages/QuotePage";
import KMUFulfillmentPage from "@/pages/KMUFulfillmentPage";
import FulfillmentDienstleisterPage from "@/pages/FulfillmentDienstleisterPage";
import InternationalerVersandPage from "@/pages/InternationalerVersandPage";
import ShopifyFulfillmentPage from "@/pages/ShopifyFulfillmentPage";

// Layout
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/leistungen" element={<ServicesPage />} />
              <Route path="/kmu-fulfillment" element={<KMUFulfillmentPage />} />
              <Route path="/fulfillment-dienstleister" element={<FulfillmentDienstleisterPage />} />
              <Route path="/internationaler-versand-b2b" element={<InternationalerVersandPage />} />
              <Route path="/shopify-fulfillment" element={<ShopifyFulfillmentPage />} />
              <Route path="/unternehmen" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/angebot" element={<QuotePage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
